export const colours = {
  primaryUI: "#003141",
  primaryUILight: "#75938F",
  primaryUILighter: "#81B3B5",
  secondaryUI: "#CD5B5D",
  greenSpace: "#76AB80",
  offWhite: "#F2EDEE"
}
